import Plyr from 'plyr';

export default class Video {
	static init() {
		Array.prototype.forEach.call(document.querySelectorAll('.video__player'), el => {
			new Video(el)
		});
	}

	constructor(element) {
		new Plyr(element, {
			iconUrl: '/_Resources/Static/Packages/CodeQ.Site/plyr.svg',
			controls: [
				'play-large',
				'play',
				'progress',
				'current-time',
				'duration',
				'mute',
				'fullscreen',
			],
			fullscreen: {
				enabled: true,
				fallback: true,
				iosNative: 'force' // Use the native fullscreen in iOS (disables custom controls)
			}
		});
	}
}
